import Axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { getApis } from '../library/Apis';
import api from '../services/api';

export const toRequest = <Type = any>(
  requestMethod: | typeof Axios.get | typeof Axios.post | typeof Axios.put | typeof Axios.delete,
  requestMethodOnlineParams: | [string] | [string, AxiosRequestConfig | any] | [string, any, AxiosRequestConfig],
  offlineJSONName?: string,
  mock?: boolean
): Promise<AxiosResponse<Type>> => {
  if (getApis()?.isOffline || mock) {
    const url = `/assets/mock/${offlineJSONName}.json`;
    return api.get(url).catch(error => {
      console.error(`Failed to load mock data from ${url}:`, error);
      return Promise.reject(new Error(`Failed to load mock data from ${url}`));
    });
  } else {
    return requestMethod.apply({}, requestMethodOnlineParams as any) as Promise<AxiosResponse<Type>>;
  }
};

export const getMergedParamsFromObject = (obj: object) => {
  return Object.entries(obj)
    .filter(
      (it) =>
        it[1] !== undefined &&
        it[1] !== null &&
        it[1] !== '' &&
        (!Array.isArray(it[1]) || it[1].length)
    )
    .map((it) => {
      return `${it[0]}=${it[1]}`;
    })
    .join('&');
};

interface ErrorDetails {
  message: string;
}

interface ErrorRequest {
  details?: ErrorDetails[];
  message?: string;
}

export const getErrorMessage = (errorRequest: ErrorRequest): string | null => {
  if (typeof errorRequest === 'object') {
    if (
      Array.isArray(errorRequest.details) &&
      errorRequest.details.length > 0
    ) {
      return errorRequest.details[0].message;
    } else if (errorRequest.message) {
      return errorRequest.message;
    }
  }
  return null;
};
